// extracted by css-extract-rspack-plugin
export default {"small":"small-DWcDO","medium":"medium-34G1g","large":"large-3-OIv"};